// components/extras/ExtraCategoryTabs.js
// Tab per navigare tra le categorie dell'extra

import React from 'react';

const ExtraCategoryTabs = ({
  categories,
  activeCategory,
  onCategoryChange,
  categoryItemCounts,
  disabledCategories = []
}) => {
  return (
    <div className="overflow-x-auto">
      <div className="flex gap-2 min-w-max pb-2" data-testid="extra-category-tabs">
        {categories.map((cat) => {
          const isDisabled = disabledCategories.includes(cat.code);
          return (
            <button
              key={cat.code}
              onClick={() => !isDisabled && onCategoryChange(cat.code)}
              disabled={isDisabled}
              data-testid={`category-tab-${cat.code}`}
              title={isDisabled ? 'Categoria non disponibile per questo tipo di extra' : ''}
              className={`
                px-4 py-2 rounded-lg text-sm font-medium transition-all whitespace-nowrap
                flex items-center gap-2
                ${isDisabled
                  ? 'bg-gray-100 text-gray-400 cursor-not-allowed opacity-50'
                  : activeCategory === cat.code 
                    ? 'bg-[#FF7819] text-white' 
                    : 'bg-white border border-[#DCDCDC] text-[#3C3C3C] hover:border-[#FF7819]'
                }
              `}
            >
              {cat.code} - {cat.label}
              {categoryItemCounts[cat.code] > 0 && (
                <span className={`
                  px-2 py-0.5 rounded-full text-xs
                  ${activeCategory === cat.code 
                    ? 'bg-white/20 text-white' 
                    : 'bg-[#FF7819]/10 text-[#FF7819]'
                  }
                `}>
                  {categoryItemCounts[cat.code]}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ExtraCategoryTabs;
